"use client";
import { Building2, UserRound } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";
import { getOwnerHref } from "@/lib/utils/text";
import type { PublicListingPublisher } from "@/lib/types/search";

export default function ListingPublisherByline({
  publisher,
  linked = true,
}: {
  publisher?: PublicListingPublisher | null;
  linked?: boolean;
}) {
  const t = useTranslations("listing");
  if (!publisher) return null;
  const Icon = publisher?.type === "AGENCY" ? Building2 : UserRound;
  return (
    <div className="relative z-10 mt-1 flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-muted-foreground">
      {publisher &&
        (publisher.isPageVisible && linked ? (
          <Link
            href={getOwnerHref(publisher.type, publisher.slug)}
            className="inline-flex min-w-0 max-w-full items-center gap-1.5 hover:text-foreground hover:underline"
          >
            <Icon aria-hidden className="size-3.5 shrink-0" />
            <span className="truncate">{publisher.name}</span>
          </Link>
        ) : (
          <span className="inline-flex min-w-0 max-w-full items-center gap-1.5">
            <Icon aria-hidden className="size-3.5 shrink-0" />
            <span className="truncate">{publisher.name}</span>
          </span>
        ))}
      {publisher.isDirect && (
        <span className="rounded bg-secondary/70 px-1.5 py-0.5 text-secondary-foreground">
          {t("origin-direct")}
        </span>
      )}
    </div>
  );
}
